/**
 * @description Метод формирует и возвращает url изображения аватара юзера
 * Принимает userID как обязательный параметр
 */
export const getUserImageURL = (
  userID: number,
  avatarSize: number,
  removeSizeFromImgUrl?: boolean
): string => {
  const path = `${"000000000000".substr(
    0,
    12 - userID.toString().length
  )}${userID}`;
  const fullPath = `https://cdn.litres.ru/pub/avatar/100/${path.substr(
    0,
    2
  )}/${path.substr(2, 2)}/${path.substr(4, 2)}/${path.substr(
    6,
    2
  )}/${path.substr(8, 2)}/${path.substr(10, 2)}/${userID}.jpg`;

  if (!removeSizeFromImgUrl) {
    return fullPath.replace(`${userID}.jpg`, `${userID}_${avatarSize}.jpg`);
  }

  return fullPath;
};

/**
 * @description Метод формирует и возвращает url изображения аватара автора
 * Принимает authorID как обязательный параметр
 */
export const getAuthorImageURL = (
  authorID: number,
  avatarSize: number,
  removeSizeFromImgUrl?: boolean
): string => {
  const path = `${"000000000000".substr(
    0,
    10 - authorID.toString().length
  )}${authorID}`;
  const fullPath = `https://cdn.litres.ru/pub/authors/1${path.substr(
    0,
    2
  )}/${path.substr(2, 2)}/${path.substr(4, 2)}/${path.substr(
    6,
    2
  )}/${"00000000".substr(0, 8 - authorID.toString().length)}${authorID}.jpg`;

  if (!removeSizeFromImgUrl) {
    return fullPath.replace(`${authorID}.jpg`, `${authorID}_${avatarSize}.jpg`);
  }

  return fullPath;
};
